import React from 'react';
import OutsideFormInput from 'components/Input/OutsideFormInput';

interface ITerminalIdField {
	value: string;
	settingsId: string;
	onChange: (value: string) => void;
}

const TerminalIdField: React.FC<ITerminalIdField> = ({ onChange, value, settingsId }) => {
	return (
		<OutsideFormInput
			testId="TerminalIdField"
			name="terminalId"
			label="terminalIdLabel"
			errorMessage="enterTerminalId"
			blockId={settingsId}
			value={value}
			onChange={onChange}
		/>
	);
};

export default React.memo(TerminalIdField);
